// import CryptoJS from 'crypto-js'
import axios from 'axios'
import { store } from '@/store'

// const apiKeyhash = CryptoJS.SHA256('fusion_' + getApiKeyFormattedDate() + '_MfdAkEaf!').toString()

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    apiKey: 'fusion',
    // apiKeyEncrypted: apiKeyhash,
    Accept: 'application/json',
    'Content-type': 'application/json',
    'Accept-Language': store.state.locale
  }
})

// function getApiKeyFormattedDate () {
//   const currentDate = new Date()
//   const mm = currentDate.getMonth() + 1 // Months start at 0!
//   const dd = currentDate.getDate()
//   let formattedDate = (dd < 10) ? '0' + dd : dd.toString()
//   formattedDate += (mm < 10) ? '0' + mm : mm.toString()
//   formattedDate += currentDate.getFullYear().toString()
//   formattedDate += currentDate.getHours().toString()

//   return formattedDate
// }

export default httpClient
